import { Form, Input, Tooltip } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntUnitMeasurement } from "../../../../models/handBooks/unitMeasurement";
import { SelectUnitMeasurementCategory } from "../../../../components/selects";
import { aliasText } from "../../../../utils";

enum FormField {
    nameKy,
    alias,
    measurementCategoryId,
    nameRu
}
interface IProps {
    show: boolean;
    unitMeasurement: EntUnitMeasurement;
    onHide: () => void;
    onSubmit: (pos: EntUnitMeasurement) => Promise<boolean>;
}

export const AddUnitMeasurementModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);


    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.alias, value: props.unitMeasurement.alias },
            { name: FormField.nameKy, value: props.unitMeasurement.nameKy },
            { name: FormField.nameRu, value: props.unitMeasurement.nameRu },
            { name: FormField.measurementCategoryId, value: props.unitMeasurement.unitMeasurementCategoryResponse?.id },
        ]);
    }

    const setEntityFromFields = (): EntUnitMeasurement => {
        let unitMeasurement = _.cloneDeep(props.unitMeasurement);
        unitMeasurement.alias = form.getFieldValue(FormField.alias);
        unitMeasurement.nameKy = form.getFieldValue(FormField.nameKy);
        unitMeasurement.nameRu = form.getFieldValue(FormField.nameRu);
        unitMeasurement.measurementCategoryId = form.getFieldValue(FormField.measurementCategoryId);
        return unitMeasurement;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);
            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>


            <DraggableModal
                title={props.unitMeasurement.id === 0 ? t('handbooks.units_of_measurement.add_units_of_measurement') : t('handbooks.units_of_measurement.edit_units_of_measurement')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >

                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >

                    <Tooltip title={aliasText} >
                        <Form.Item
                          label={t('general.alias')}
                          name={FormField.alias}
                          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                        >
                            <Input maxLength={255} showCount autoComplete="off" />
                        </Form.Item>
                    </Tooltip>
                    <Form.Item
                        label={t('Категория')}
                        name={FormField.measurementCategoryId}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <SelectUnitMeasurementCategory />
                    </Form.Item>
                    <Form.Item
                        label={t('general.nameKy')}
                        name={FormField.nameKy}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('general.nameRu')}
                        name={FormField.nameRu}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>

                </Form>
            </DraggableModal>

        </>

    )
}
